import rating from "../component/Rating";


interface RatingOnCategory {
    customization: number
    features: number
    apps: number
    excitement: number
    updates: number
    easeOfUse: number
    ecoSystem: number
}
const iosRanking : RatingOnCategory = {
    customization: 0,
    features: 0,
    easeOfUse: 1,
    updates: 1,
    apps: 1,
    excitement: 0,
    ecoSystem: 1
}

const android: RatingOnCategory = {
    customization: 1,
    features : 1,
    easeOfUse: 0,
    updates: 0,
    apps: 0,
    excitement: 1,
    ecoSystem: 0
}
export interface WhoYouAre {
    type: "Android" | "Apple" | "Tie"
}

function score(userRating: RatingOnCategory, deviceRating : RatingOnCategory) {

    return (userRating.customization * deviceRating.customization) +
        (userRating.ecoSystem * deviceRating.ecoSystem) +
        (userRating.apps * deviceRating.apps) +
        (userRating.updates * deviceRating.updates) +
        (userRating.features * deviceRating.features) +
        (userRating.easeOfUse * deviceRating.easeOfUse) +
        (userRating.excitement * deviceRating.excitement)
}

export function whoAmI(rating: RatingOnCategory) : WhoYouAre {

    const androidScore = score(rating, android);
    const iosScore = score(rating, iosRanking);

    if (androidScore === iosScore) return {type: "Tie"}

    return androidScore > iosScore ? {type: "Android"} : {type: "Apple"};
}
